import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=26dd2460&scoped=true&"
import script from "./basicTable.js?vue&type=script&lang=js&"
export * from "./basicTable.js?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=26dd2460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd2460",
  null
  
)

export default component.exports